import { ROUTES, callAPI } from "../API/index";
import { fetchCodeList, renameKeys } from "./ServiceCommon";

// -----------------------------------------------
// Company ( Basic Info )
// -----------------------------------------------
export const fetchCompanyDepartmentList = (corp_no) => {
    /**
     * 회사 부서 목록 반환
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.DEPARTMENT, 'GET', { }, { grp_no: 4, corp_no });
}

export const createCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 생성
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.DEPARTMENT, 'POST', apiData);
}

export const updateCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 수정
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.DEPARTMENT, 'PUT', apiData);
}

export const deleteCompanyDepartment = (apiData) => {
    /**
     * 회사 부서 목록 삭제
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.DEPARTMENT, 'DELETE', apiData);
}

export const fetchCompanyDepartmentMenuItems = async (corp_no) => {
    /**
     * 회사 부서 목록 MenuItems 형태로 반환
     */
    try {
        const data = await fetchCompanyDepartmentList(corp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], deptNm: 'text' };
        // console.log(data);
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap));
        return menuItems; // Promise 반환
    } catch (error) {
        console.error("부서 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
};

export const fetchCompanyPositionList = (corp_no) => {
    /**
     * 회사 직위 목록 반환
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.POSITION, 'GET', {}, { grp_no: 4, corp_no });
}

export const createCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 생성
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.POSITION, 'POST', apiData);
}

export const updateCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 수정
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.POSITION, 'PUT', apiData);
}

export const deleteCompanyPosition = (apiData) => {
    /**
     * 회사 직위 목록 삭제
     */
    return callAPI(ROUTES.BASIC_INFO.COMPANY_INFO.POSITION, 'DELETE', apiData);
}

export const fetchCompanyPositionMenuItems = async (corp_no) => {
    /**
     * 회사 직위 목록 MenuItems 형태로 반환
     */
    try {
        const data = await fetchCompanyPositionList(corp_no); // API 호출
        const menuItemKeyMap = { no: ['key', 'value'], ofcpsNm: 'text' };
        // console.log(data);
        const menuItems = data.map(item => renameKeys(item, menuItemKeyMap));
        return menuItems; // Promise 반환
    } catch (error) {
        console.error("직위 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanyAttendanceList = (corp_no, type) => {
    /**
     * 회사 근태 목록 반환
     */
    return callAPI(ROUTES.BASIC_INFO.ATTENDANCE, 'GET', {}, { corp_no, type });
}

export const fetchCompanyAttendanceListItems = async (corp_no) => {
    /**
     * 회사 근태목록 반환
     */
    try {
        const resp = await fetchCompanyAttendanceList(corp_no); // API 호출

        // 1:근무시간, 2:휴식시간, 3:정보성, 4:기본 주휴일, 5:소정근로시간, 6:연장제외, 7:연장최대, 8:근무 최소단위 code: 0020
        const companyAttendance_worktime = resp.filter(item => item.laborType === '0001');
        const companyAttendance_resttime = resp.filter(item => item.laborType === '0002');
        const companyAttendance_info = resp.filter(item => item.laborType === '0003');
        const companyAttendance_weekend = resp.find(item => item.laborType === '0004');
        const companyAttendance_cwh = resp.find(item => item.laborType === '0005');
        const companyAttendance_extend_exclude = resp.find(item => item.laborType === '0006');
        const companyAttendance_extend_max = resp.find(item => item.laborType === '0007');
        const companyAttendance_min_unit = resp.find(item => item.laborType === '0008');

        return {
            worktime: companyAttendance_worktime,
            resttime: companyAttendance_resttime,
            info: companyAttendance_info,
            weekend: companyAttendance_weekend,
            cwh: companyAttendance_cwh,
            extend_exclude: companyAttendance_extend_exclude,
            extend_max: companyAttendance_extend_max,
            min_unit: companyAttendance_min_unit
        }
    } catch (error) {
        console.error("근태 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const updateCompanyAttendanceList = (apiData) => {
    /**
     * 회사 근태 목록 수정
     */
    return callAPI(ROUTES.BASIC_INFO.ATTENDANCE, 'PUT', apiData);
}

export const createCompanyAttendance = (apiData) => {
    /**
     * 회사 근태 목록 생성
     */
    return callAPI(ROUTES.BASIC_INFO.ATTENDANCE, 'POST', apiData);
}

export const deleteCompanyAttendance = (apiData) => {
    /**
     * 회사 근태 목록 삭제
     */
    return callAPI(ROUTES.BASIC_INFO.ATTENDANCE, 'DELETE', apiData);
}

export const fetchAttendanceCodeList = async () => {
    /**
     * 근태 코드 목록 반환
     */
    try {
        const data = await fetchCodeList(["0031", "0033", "0034"]); // API 호출
        const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }

        const resp = data.code_list
        const resp_message = data.message
        const menuItems0031 = resp.filter((item) => item.category === "0031" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })
        const menuItems0033 = resp.filter((item) => item.category === "0033" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })
        const menuItems0034 = resp.filter((item) => item.category === "0034" && item.subcategory !== "0000").map(item => {
            const { category, ...rest } = item;
            return renameKeys(rest, menuItemKeyMap);
        })

        return {
            scheduleMenuItems: menuItems0031,
            atendJdgmntMenuItems: menuItems0033,
            lvofcJdgmntMenuItems: menuItems0034,
            resp_message: resp_message
        }
    } catch (error) {
        console.error("근태 코드 목록 가져오기 오류:", error);
        throw error; // 오류를 다시 던져서 호출하는 쪽에서 처리할 수 있도록 함
    }
}

export const fetchCompanySalaryList = async (corp_no, salaryItemType) => {
    /**
     * 회사 급여 목록 반환
     */
    const resp = await callAPI(ROUTES.BASIC_INFO.SALARY, 'GET', {}, { corp_no, salaryItemType });
    if (resp) {
        const salary_item_info = resp.filter(item => item.salaryTypeStr !== '기준 항목')
        console.log("salary_item_info", salary_item_info)
        return salary_item_info
    } else {
        return []
    }
}

export const fetchCompanySalaryListBasic = async (corp_no, salaryItemType) => {
    /**
     * 회사 급여 목록 기준 항목 반환
     */
    const resp = await callAPI(ROUTES.BASIC_INFO.SALARY, 'GET', {}, { corp_no, salaryItemType });

    if (resp) {
        const basic_info = resp.filter(item => item.salaryTypeStr === '기준 항목')
        return basic_info
    } else {
        return []
    }
}

export const fetchCompanySalaryItemList = async (corp_no, salaryItemType, salaryTypeStr, basicYn) => {
    /**
     * 회사 급여 목록 반환 - 급여 항목 추가가 용
     */
    const resp = await callAPI(ROUTES.BASIC_INFO.SALARY, 'GET', {}, { corp_no, salaryItemType, salaryTypeStr, basicYn });
    if (resp) {
        const salary_item_info = resp.filter(item => item.salaryTypeStr !== '기준 항목')
        console.log("salary_item_info", salary_item_info)
        return salary_item_info
    } else {
        return []
    }
}

export const fetchCompanySalaryTypeMenuItems = async () => {
    /**
     * 회사 급여 타입 목록 MenuItems 형태로 반환
     */
    const resp = await fetchCodeList(["0016"])
    const menuItemKeyMap = { subcategory: ['key', 'value'], value: 'text' }
    const menuItems = resp.code_list.filter(item => item.category === "0016" && item.subcategory !== "0000").map((item) => renameKeys(item, menuItemKeyMap))
    return menuItems
}

export const createCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 생성
     */
    return callAPI(ROUTES.BASIC_INFO.SALARY, 'POST', apiData);
}

export const updateCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 수정
     */
    return callAPI(ROUTES.BASIC_INFO.SALARY, 'PUT', apiData);
}

export const deleteCompanySalary = (apiData) => {
    /**
     * 회사 급여 목록 삭제
     */
    return callAPI(ROUTES.BASIC_INFO.SALARY, 'DELETE', apiData);
}

export const fetchCompanyHolidayList = (corp_no) => {
    /**
     * 회사 공휴일 목록 반환
     */
    return callAPI(ROUTES.BASIC_INFO.HOLIDAY, 'GET', {}, { corp_no });
}

export const createCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 생성
     */
    return callAPI(ROUTES.BASIC_INFO.HOLIDAY, 'POST', apiData);
}

export const updateCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 수정
     */
    return callAPI(ROUTES.BASIC_INFO.HOLIDAY, 'PUT', apiData);
}

export const deleteCompanyHoliday = (apiData) => {
    /**
     * 회사 공휴일 목록 삭제
     */
    return callAPI(ROUTES.BASIC_INFO.HOLIDAY, 'DELETE', apiData);
}


